import "./FAQ.css";
import React, { useState } from "react";
import HangingMenus from "../common-components/HangingMenus";


const Accordion = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion__title" onClick={() => setIsActive(!isActive)}>
        <div>{title}</div>
        <span className="accordion__icon">
          {isActive ? (
            <img
              className="accordion__button__icons"
              src="/images/FAQ/Negative.svg"
              alt="banner"
            />
          ) : (
            <img
              className="accordion__button__icons"
              src="/images/FAQ/plus.svg"
              alt="banner"
            />
          )}
        </span>
      </div>
      {isActive && <div className="accordion__content">{content}</div>}
    </div>
  );
};


const FAQ = () => {

  const accordionData = [
    {
      title: "What is a blended training?",
      content: `Blended trainings are self-paced learning offerings supported with SME connect sessions to clarify the doubts/queries from the learners`,
    },
    {
      title: "Is WBSe provided for blended training?",
      content: `No, WBSe is not provided for blended trainings as they are self-paced and do not impact project deliverables`,
    },
    {
      title: "When will the training invites be sent to learners?",
      content: `Training invites are shared with confirmed nominees 3 days prior to the training`,
    },
    {
      title: "Do I get participation certificate when I complete L&TT lateral training?",
      content: `No`,
    },
    {
      title: "Can I add the skills for which I am training on Enterprise Platforms to myCompetency?",
      content: `Yes, and if you have already completed your training successfully, the relevant skill will be added to myCompetency within that month`,
    },
    {
      title: "Can I attend only certain days of the training?",
      content: `No, all attendees are requested to attend the entire training program on all days as per the schedule. Any exceptions need to be approved by DULs.`,
    },
    {
      title: "Can I cancel my nomination?",
      content: `While there are no cost implications for canceling a nomination, any last-minute cancellation is not accepted and should be re-filled by other learners.`,
    },
    {
      title: "What is the project cost for the trainings?",
      content: `There is no explicit project cost for internal trainings unless it is an external vendor training`,
    },
  ];

 

  return (
    <>
      {/* Banner image */}
      <img className="FAQ__banner" src="/images/FAQ/FAQ_img.png" alt="banner" />

      {/* About text */}
      <div className="FAQ__about__text">
        <h2>Dive into FAQ</h2><br/>
        <p className="FAQ__about__para">
          This page contains answers to all essential questions about Enterprise Platforms, from finding the right training to registering and getting certified, and more.
        </p>
      </div>

      {/* FAQ Question accordion */}
      <div className="FAQ__Accordion__container">
        <div>
          <div className="accordion">
            {accordionData.map(({ title, content }) => (
              <Accordion title={title} content={content} />
            ))}
          </div>
        </div>
      </div>
      <HangingMenus />
    </>
  );
};

export default FAQ;
